import React, { Component } from 'react';
import { Paper, Box, Typography, Button, LinearProgress } from '@mui/material';
import { MonitorWeight, Edit } from '@mui/icons-material';

class WeightStatusCard extends Component {
    render() {
        const { weight, maxWeight, isAdmin, onEdit } = this.props;
        const percentage = ((weight / maxWeight) * 100).toFixed(2);
        const percentageNum = parseFloat(percentage);

        // Color based on percentage
        const getProgressColor = () => {
            if (percentageNum >= 90) return '#f57c00'; // Orange warning
            if (percentageNum >= 70) return '#fdd835'; // Yellow caution
            return '#66bb6a'; // Soft green
        };

        return (
            <Paper
                elevation={3}
                sx={{
                    flex: '1 1 300px',
                    minWidth: { xs: '100%', sm: '280px', md: '300px' },
                    width: { xs: '100%', sm: 'auto' },
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                        transform: { xs: 'none', sm: 'translateY(-2px)' }
                    }
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        background: 'linear-gradient(135deg, #81c784 0%, #a5d6a7 100%)',
                        p: { xs: 1.2, sm: 1.5 },
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        gap: { xs: 0.8, sm: 1 }
                    }}
                >
                    <MonitorWeight sx={{ fontSize: { xs: '1.1rem', sm: '1.3rem' } }} />
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: { xs: '0.85rem', sm: '0.95rem' } }}>
                        Gesamtgewicht
                    </Typography>
                </Box>

                <Box sx={{ p: { xs: 1.5, sm: 2 } }}>
                    {isAdmin ? (
                        <>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 1 }}>
                                <Typography 
                                    variant="h5" 
                                    sx={{ 
                                        fontWeight: 700, 
                                        color: '#2e7d32'
                                    }}
                                >
                                    {weight} Kg
                                </Typography>
                                <Typography 
                                    variant="body2" 
                                    sx={{ 
                                        color: '#888',
                                        fontSize: '0.85rem'
                                    }}
                                >
                                    von {maxWeight} Kg
                                </Typography>
                            </Box>

                            {/* Progress Bar */}
                            <Box sx={{ mb: 1.5 }}>
                                <LinearProgress 
                                    variant="determinate" 
                                    value={percentageNum > 100 ? 100 : percentageNum}
                                    sx={{
                                        height: 8,
                                        borderRadius: 4,
                                        bgcolor: '#e8f5e9',
                                        '& .MuiLinearProgress-bar': {
                                            bgcolor: getProgressColor(),
                                            borderRadius: 4
                                        }
                                    }}
                                />
                                <Typography 
                                    variant="caption" 
                                    sx={{ 
                                        color: '#888',
                                        fontSize: '0.75rem',
                                        display: 'block',
                                        mt: 0.5
                                    }}
                                >
                                    {percentage}% erreicht
                                </Typography>
                            </Box>

                            <Button 
                                variant="outlined"
                                fullWidth
                                size="small"
                                startIcon={<Edit />}
                                onClick={onEdit}
                                sx={{
                                    borderColor: '#81c784',
                                    color: '#2e7d32',
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                    py: 0.5,
                                    fontSize: '0.85rem',
                                    '&:hover': {
                                        borderColor: '#66bb6a',
                                        bgcolor: '#f1f8e9'
                                    }
                                }}
                            >
                                Ändern
                            </Button>
                        </>
                    ) : (
                        <>
                            <Typography 
                                variant="h5" 
                                sx={{ 
                                    fontWeight: 700, 
                                    color: '#2e7d32',
                                    mb: 1
                                }}
                            >
                                {percentage}%
                            </Typography>

                            {/* Progress Bar */}
                            <Box sx={{ mb: 0.5 }}>
                                <LinearProgress 
                                    variant="determinate" 
                                    value={percentageNum > 100 ? 100 : percentageNum}
                                    sx={{
                                        height: 8,
                                        borderRadius: 4,
                                        bgcolor: '#e8f5e9',
                                        '& .MuiLinearProgress-bar': {
                                            bgcolor: getProgressColor(),
                                            borderRadius: 4
                                        }
                                    }}
                                />
                            </Box>
                            <Typography 
                                variant="caption" 
                                sx={{ 
                                    color: '#888',
                                    fontSize: '0.8rem'
                                }}
                            >
                                des Gesamtgewichts erreicht
                            </Typography>
                        </>
                    )}
                </Box>
            </Paper>
        );
    }
}

export default WeightStatusCard;
